import React, { useEffect, useState } from 'react'
import { trimLowerCase } from '../../../utils/utils'
import { styles } from './style'
import { useAvailableSlots } from "../store/stateProvider"
import lodash from 'lodash';
import ErrorBox from '../error-box'
import useTranslation from '../../../hooks/use-translation';
import { openBrowser } from '../../../utils/call-my-jio'
import { raiseGAEventForSlotFinder } from '../../../utils/network'
import config from '../../../config.json'

const monthMapper = {
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December'
}

const labelMap = {
  'age': 'min_age_limit',
  'vaccine': 'vaccine',
  'dose': 'dose',
  'dose1': 'available_capacity_dose1',
  'dose2': 'available_capacity_dose2'
}

const doses = {
  one: '1',
  two: '2',
  both: '1 & 2',
  none: '1 & 2 '
}

let model = {
  age: {
    label: 'Age',
    value: '',
    feeType: ''
  },
  vaccine: {
    label: 'Vaccine',
    value: '',
    feeType: ''
  },
  dose1: {
    label: 'Dose 1',
    value: '',
    feeType: ''
  },
  dose2: {
    label: 'Dose 2',
    value: '',
    feeType: ''
  }
}

export default (props) => {
  const { currentDate = '', allDateCenters = {}, renderAllDatesFunction = () => { } } = props
  const [currentElement, setCurrentElement] = useState(currentDate)
  const datesToShow = Object.keys(allDateCenters)
  const [dates, setDates] = useState(datesToShow)
  const { t } = useTranslation();
  let dataModel = []
  const [data, dispatch] = useAvailableSlots()
  const [filteredList, setFilteredList] = useState([])
  const { slots = {}, dateSlotsAvailable = true } = data
  const CalcNumber = (number) => {
    if (number > 10)
      return 'greaterThanTen'
    if (number === 0)
      return 'zero'
    return 'lessThanTen'
  }

  useEffect(() => {
    if (dates.length < datesToShow.length) { setDates(datesToShow) }
  }, [datesToShow])

  useEffect(() => {
    dispatch({ type: 'SET_DATE_SLOTS', dateSlotsAvailable: false })
    return () => {
      dispatch({ type: 'SET_DATE_SLOTS', dateSlotsAvailable: true })
    }
  }, [])

  const filterHeaderData = ({ elem = {}, totalCapacity = 0 }) => {
    let headerToRender = {}
    Object.assign(headerToRender, { hospitalName: elem['name'] })
    Object.assign(headerToRender, { hospitalAddress: elem['address'] })
    Object.assign(headerToRender, { slotNumber: totalCapacity })
    Object.assign(headerToRender, { feeType: elem['fee_type'] })
    return headerToRender
  }

  const getDataToRender = (elem = {}) => {
    let dataToRender = {}
    const requiredFields = ['fee_type', 'min_age_limit', 'vaccine', 'available_capacity_dose1', 'available_capacity_dose2']
    const { sessions = [] } = elem
    let totalCapacity = 0
    sessions.map((value) => {
      const newModel = lodash.cloneDeep(model);
      const flatElem = { ...elem, ...value }
      const elemArray = Object.keys(flatElem)
      elemArray.length && elemArray.map((value, index) => {
        requiredFields.indexOf(value) >= 0 && Object.assign(dataToRender, { [value]: flatElem[value] });
      })
      Object.keys(newModel).map((value) => {
        newModel[value]['value'] = dataToRender[labelMap[value]]
        newModel[value]['feeType'] = dataToRender['fee_type']
      })
      dataModel.push(newModel)
      totalCapacity += flatElem['available_capacity']
    })
    const headerToRender = filterHeaderData({ elem, totalCapacity })
    return headerToRender
  }

  useEffect(() => {
    const filteredSlots = slots[currentElement] || []
    setFilteredList(filteredSlots)
  }, [currentElement, slots])

  const DisplayDetails = ({ age = {}, vaccine = {}, dose1 = {}, dose2 = {}, index = '' }) => {
    return (
      <div key={index} style={(dataModel.length - 1 === index) ? styles.lastDetail : styles.displayDetail}>
        <div style={styles.columnFlex}>
          <div style={styles.headDetails}>
            {age.label}
          </div>
          <div style={styles.midDetails}>
            {`${age.value}+`}
          </div>
        </div>
        <div style={styles.columnFlex}>
          <div style={styles.headDetails}>
            {vaccine.label}
          </div>
          <div style={styles.midDetails}>
            {vaccine.value}
          </div>
        </div>
        <div style={styles.columnFlex}>
          <div style={styles.headDetails}>
            {dose1.label}
          </div>
          <div style={styles.midDetails}>
            <span style={styles[`${CalcNumber(dose1.value)}Dose`]}>{dose1.value}</span>
            <span style={styles[`${CalcNumber(dose1.value)}Slots`]}>{` ${t('SLOTS')}`}</span>
          </div>
        </div>
        <div style={styles.columnFlex}>
          <div style={styles.headDetails}>
            {dose2.label}
          </div>
          <div style={styles.midDetails}>
            <span style={styles[`${CalcNumber(dose2.value)}Dose`]}>{dose2.value}</span>
            <span style={styles[`${CalcNumber(dose2.value)}Slots`]}>{` ${t('SLOTS')}`}</span>
          </div>
        </div>
      </div>
    )
  }
  const renderPreviousElement = () => {
    const previousIndex = dates.indexOf(currentElement) - 1
    if (!outliers(previousIndex)) {
      setCurrentElement(dates[previousIndex])
    }
  }
  const renderNextElement = () => {
    const nextIndex = dates.indexOf(currentElement) + 1
    if (!outliers(nextIndex)) {
      setCurrentElement(dates[nextIndex])
    }
  }
  const outliers = (currentIndex) => currentIndex > -1 && currentIndex < dates.length ? false : true

  const bookCowin = () => {
    raiseGAEventForSlotFinder({ eventAction: 'Book on Cowin', eventLabel: 'Click' })
    openBrowser(config.cowinRegistrationLink)
  }

  function renderAllDatesView(callback) {
    callback()
  }

  const renderComponent = ({ elem = {}, index = '' }) => {
    const dataToRender = getDataToRender(elem)
    return (
      <div key={`card-${index}`} style={styles.detailsContainer}>
        <div style={styles.metadata}>
          <div style={styles.address}>
            <div style={styles.hospitalName}>
              {dataToRender.hospitalName}
            </div>
            <div style={styles.hospitalAddress}>
              {dataToRender.hospitalAddress}
            </div>
          </div>
          <div style={trimLowerCase(dataToRender.feeType) === 'free' ? styles.freeType : styles.paidType}>
            {dataToRender.feeType}
          </div>
        </div>
        <div style={styles.displayDetailsContainer}>
          {dataModel.map((value, index) => {
            return DisplayDetails({ ...value, index })
          })}
        </div>
        <div style={styles.cowinDiv}>
          <button style={styles.cowinButton} value={t('BOOK_COWIN')}
            onClick={bookCowin} >{t('BOOK_COWIN')}</button>
        </div>
      </div>
    )
  }

  return (
    <>
      <div style={styles.viewAllDates} onClick={renderAllDatesView.bind(props, renderAllDatesFunction)}>{t('VIEW_DATE')}</div>
      <div style={styles.mainContainer}>
        <div style={styles.dateNav}>
          <img src="/icons/ic_left_arrow.svg" style={{ opacity: `${dates.indexOf(currentElement) == 0 ? '0' : '1'}` }}
            onClick={renderPreviousElement} />
          <div>{formatDate(currentElement)}</div>
          <img src="/icons/ic_right_arrow.svg"
            style={{ opacity: `${dates.indexOf(currentElement) == dates.length - 1 ? '0' : '1'}` }}
            onClick={renderNextElement} />
        </div>
        {filteredList.length > 0 && filteredList.map((elem, index) => {
          dataModel = []
          return renderComponent({ elem, index })
        })}
        {filteredList.length === 0 &&
          <ErrorBox src={"/icons/ic_sad_face.svg"} label={t('NO_SLOT_DATE')} />}
      </div>
    </>
  )
}

export function formatDate(currentDate = '01-01-2021') {
  const [day, month, year] = currentDate.split('-')
  return `${day} ${monthMapper[Number(month)]} ${year}`
}